import {useEffect} from 'react';
import {supabase} from '../supabaseClient';
import {useQueryClient} from '@tanstack/react-query';
import { Message} from './useMessages';

interface UseMessengerRealtimeProps {
    userId?: string;
    activeConnectionId: string | null;
  }

export const useMessengerRealtime = ({
    userId,
    activeConnectionId
    } : UseMessengerRealtimeProps) => {

    const queryClient = useQueryClient();


    useEffect(() => {
        if (!userId) return;
    
        const handleNewMessage = (payload: { new: Message }) => {
        console.log('Single listener received message:', payload.new);
        
        queryClient.invalidateQueries({ queryKey: ['connections', userId] });
    
        queryClient.invalidateQueries({ queryKey: ['messages', payload.new.connectionId] });

        };
    
        const channel = supabase
        .channel(`global_messages_listener_for_${userId}`)
        .on(
            'postgres_changes',
            { event: 'INSERT', schema: 'public', table: 'messages' },
            handleNewMessage
        )
        .on(
            'postgres_changes',
            { event: 'UPDATE', schema: 'public', table: 'messages' },
            handleNewMessage
        )

        .subscribe();
    
        // Cleanup
        return () => {
        supabase.removeChannel(channel);
        };
    }, [queryClient, userId, activeConnectionId]);




  // Add this new listener to your MessengerPage component
  useEffect(() => {
    const refetchAll = () => {
      queryClient.invalidateQueries({ queryKey: ['connections', userId] });
      if (activeConnectionId) {
        queryClient.invalidateQueries({ queryKey: ['messages', activeConnectionId] });
      }
    };
    const onFocus = () => refetchAll();
    const onVisible = () => {
      if (document.visibilityState === 'visible') refetchAll();
    };
  
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [queryClient, userId, activeConnectionId]);

  
useEffect(() => {
  if (!userId) return;

  const handleConnectionChange = (payload: any) => {
      // console.log('A connection was deleted:', payload.old);
      // Simply refetch the connections list to make it disappear from the UI.
      queryClient.invalidateQueries({ queryKey: ['connections', userId] });
  };

  // const handleConnectionAdded = (payload: any) => {
  //     console.log('A connection was added:', payload.old);
  //     // Simply refetch the connections list to make it disappear from the UI.
  //     queryClient.invalidateQueries({ queryKey: ['connections', userId] });
  // }

  const channel = supabase
    .channel(`global_connections_listener_for_${userId}`)
    .on(
      'postgres_changes',
      // ✅ Listen for DELETE events on the 'connections' table
      { event: '*', schema: 'public', table: 'connections' },
      handleConnectionChange
    )
    // .on(
    //   'postgres_changes',
    //   { event: 'UPDATE', schema: 'public', table: 'connections' },
    //   handleConnectionAdded
    // )
    // .on(
    //   'postgres_changes',
    //   { event: 'UPDATE', schema: 'public', table: 'connections' },
    //   handleConnectionAdded
    // )
    .subscribe();

  return () => {
      supabase.removeChannel(channel);
  };
}, [queryClient, userId]);

}